'use client'
import React, { useEffect } from 'react'

import EducationExperience from './EducationExperience.mobile'
import WorkExperience from './WorkExperience.mobile'

export const ResumeOnlineMain = (props: { lang: any; config: any; step: any }) => {
  const { step } = props

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.scroll(0, 0)
      }, 100)
    }
  }, [step])

  const renderContent = () => {
    if (step == 6) {
      return <WorkExperience {...props} />
    }
    return <EducationExperience {...props} />
  }

  return <>{renderContent()}</>
}

export default ResumeOnlineMain
